import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    marginTop: theme.spacing(2),
  },
  iframe: {
    height: 500,
    width: 1,
    minWidth: '100%',
    border: 'none',
  },
}));

import type { Event } from '../../types/Event';

type Props = {
  event?: Event;
};

const EventRouteMap = ({ event: { routeUrl } }: Props) => {
  const { classes } = useStyles();

  if (!routeUrl) {
    return null;
  }

  const publicMatch = routeUrl.match(/ridewithgps.com\/routes\/(\d+)/);
  if (!publicMatch) {
    return null;
  }
  const routeId = publicMatch[1];

  let privacyCode;
  const privacyCodeMatch = routeUrl.match(/privacy_code=([a-zA-Z0-9]+)/);
  if (privacyCodeMatch) {
    privacyCode = privacyCodeMatch[1];
  }

  // <iframe src="https://ridewithgps.com/embeds?type=route&id=30995437&sampleGraph=true&privacyCode=SBmzELTo0AFlqZAR" style="width: 1px; min-width: 100%; height: 700px; border: none;" scrolling="no"></iframe>
  const embedUrl = `https://ridewithgps.com/embeds?type=route&id=${routeId}&sampleGraph=true${privacyCode ? `&privacyCode=${privacyCode}` : ''}`;

  return (
    <div className={classes.wrapper}>
      <iframe
        src={embedUrl}
        scrolling="no"
        className={classes.iframe}
      />
    </div>
  );
};

export default EventRouteMap;
